{
  "jira-ops-unified-view-revamp.grouped-alerts.spotlight.body": [
    {
      "type": 0,
      "value": "Expand to quickly view all alerts in the group."
    }
  ],
  "jira-ops-unified-view-revamp.grouped-alerts.spotlight.title": [
    {
      "type": 0,
      "value": "View grouped alerts"
    }
  ],
  "jira-ops-unified-view-revamp.snr-header.spotlight.body": [
    {
      "type": 0,
      "value": "Rovo helps you classify your alerts as signal or noise so you can focus on what matters most."
    }
  ],
  "jira-ops-unified-view-revamp.snr-header.spotlight.title": [
    {
      "type": 0,
      "value": "Triage alerts faster"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.go-back": [
    {
      "type": 0,
      "value": "Go back"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-ops-unified-view-revamp.spotlight.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ]
}